import { set, getOr } from 'lodash/fp';
import createReducer from '../../../../../../helpers/createReducer';
import {
  fetchROItemForEdit,
  updateROItem,
  fetchROItemAssocPicklistCount
} from '../../../../sagas/routines';
import { resetROItemEdit } from '../../../../actions/routes/ro-item/edit';

const initialState = {
  data: null,
  fetching: false,
  fetched: false,
  itemPicklistCount: 0,
  isFetchingItemPicklistCount: false,
  isFetchedItemPicklistCount: false,
  saving: false,
  saved: false
};

const fetchROItemEditHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const updateROItemEditHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

const fetchROItemAssocPicklistCountHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    isFetchingItemPicklistCount: true,
    isFetchedItemPicklistCount: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('itemPicklistCount', getOr(0, 'count', response), state),
  [routine.FULFILL]: state => ({
    ...state,
    isFetchingItemPicklistCount: false,
    isFetchedItemPicklistCount: true
  })
});

const restROItemEditHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchROItemEditHandler(fetchROItemForEdit),
  ...fetchROItemAssocPicklistCountHandler(fetchROItemAssocPicklistCount),
  ...updateROItemEditHandler(updateROItem),
  ...restROItemEditHandler(resetROItemEdit)
});
